import { attendanceMap } from "./attendance";
import { paginationMap } from "./pagination";

export const paginatedAttendancesMap: GenericObject = {
	results: attendanceMap,
	...paginationMap,
};
